/* eslint-disable no-param-reassign */
const state = {
  associateJobModal: false,
  transferResumeModal: false,
  shareModal: false,
  candidateListModal: false,
  exportModal: null,
  poolControlModal: false,
  removeFromListModal: false,
  filterModal: false,
  sendMessageModal: false,
  detailKeywordModal: false,
  detailCompanyModal: false,
  kvkkTextModal: false,
  imageUploadModal: false,
  periodProductModal: false,
  passResumeModal: false,
  inventoryModal: false,
  errorModal: false,
};

// getters
const getters = {
  getAssociateJobModal: (state) => state.associateJobModal,
  getTransferResumeModal: (state) => state.transferResumeModal,
  getShareModal: (state) => state.shareModal,
  getCandidateListModal: (state) => state.candidateListModal,
  getExportModal: (state) => state.exportModal,
  getPoolControlModal: (state) => state.poolControlModal,
  getRemoveFromListModal: (state) => state.removeFromListModal,
  getFilterModal: (state) => state.filterModal,
  getSendMessageModal: (state) => state.sendMessageModal,
  getDetailKeywordModal: (state) => state.detailKeywordModal,
  getDetailCompanyModal: (state) => state.detailCompanyModal,
  getKvkkListModal: (state) => state.kvkkTextModal,
  getImageUploadModal: (state) => state.imageUploadModal,
  getPeriodProductModal: (state) => state.periodProductModal,
  getPassResumeModal: (state) => state.passResumeModal,
  getInventoryModal: (state) => state.inventoryModal,
  getErrorModal: (state) => state.errorModal,
};
// mutations
const mutations = {
  setModals (state, obj) {
    state[obj.modal] = obj.value;
  },
};
// actions
const actions = {
  setModals: (context, obj) => {
    context.commit('setModals', obj);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
